import gql from "graphql-tag";

export default gql`
  subscription SubscribeToActuatorStatusChanges($id: Int!) {
    subscribeToActuatorStatusChanges(id: $id)
  }
`;
